module.exports = __webpack_public_path__ + "img/composer-video.7f9771d1.svg";